import { useProvider } from '@newfront-insurance/react-provision';
import { useMemo } from 'react';

import { createNovaTransport } from '../lib/transport';
import { useNovaContext } from '../providers';

/**
 * Hook to create and memoize the Nova chat transport.
 * Uses context values and auth provider to configure the transport.
 * The transport is recreated when context values change.
 */
export function useChatTransport() {
  const { userUuid, accountUuid, authProvider, apiEndpoint, baseUrl } = useNovaContext();
  const { getToken } = useProvider(authProvider);

  const transport = useMemo(() => {
    return createNovaTransport({
      apiEndpoint,
      baseUrl,
      getToken,
      userUuid,
      accountUuid,
    });
  }, [accountUuid, apiEndpoint, baseUrl, getToken, userUuid]);

  return transport;
}
